import { render, staticRenderFns } from "./global-search-input.vue?vue&type=template&id=1c5f3c34&scoped=true"
import script from "./global-search-input.vue?vue&type=script&lang=js"
export * from "./global-search-input.vue?vue&type=script&lang=js"
import style0 from "./global-search-input.vue?vue&type=style&index=0&id=1c5f3c34&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5f3c34",
  null
  
)

export default component.exports